import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.7247 11.3725H17.7975C18.5971 11.3725 19 10.8858 19 9.88222V6.4828C19 5.47891 18.5971 5 17.7975 5H13.7247C12.9251 5 12.5223 5.47891 12.5223 6.4828V9.88222C12.5223 10.8858 12.9251 11.3725 13.7247 11.3725ZM6.20219 11.3725H10.275C11.0746 11.3725 11.4775 10.8858 11.4775 9.88222V6.4828C11.4775 5.47891 11.0746 5 10.275 5H6.20219C5.40288 5 5 5.47891 5 6.4828V9.88222C5 10.8858 5.40288 11.3725 6.20219 11.3725ZM6.20219 19H10.275C11.0746 19 11.4775 18.5211 11.4775 17.5172V14.1103C11.4775 13.1142 11.0746 12.6275 10.275 12.6275H6.20219C5.40288 12.6275 5 13.1142 5 14.1103V17.5172C5 18.5211 5.40288 19 6.20219 19ZM13.7247 19H17.7975C18.5971 19 19 18.5211 19 17.5172V14.1103C19 13.1142 18.5971 12.6275 17.7975 12.6275H13.7247C12.9251 12.6275 12.5223 13.1142 12.5223 14.1103V17.5172C12.5223 18.5211 12.9251 19 13.7247 19Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }